import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import InviteAcceptPage from './pages/InviteAcceptPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SettingsPage from './pages/SettingsPage';
import DigitalDashboard from './modules/digital/DigitalDashboard';
import DigitalClientsPage from './modules/digital/DigitalClientsPage';
import DigitalClientDetail from './modules/digital/DigitalClientDetail';
import BrandDetail from './modules/digital/BrandDetail';
import DigitalPlanEditor from './modules/digital/DigitalPlanEditor';
import UsersPage from './modules/digital/UsersPage';
import AdminPage from './modules/admin/AdminPage';
import PlatformsPage from './modules/digital/PlatformsPage';
import AudiencesPage from './modules/digital/AudiencesPage';
import BrandsPage from './modules/digital/BrandsPage';
import AccountOverviewPage from './modules/digital/AccountOverviewPage';
import SitesPage from './modules/digital/SitesPage';
import AgencySummaryPage from './modules/digital/AgencySummaryPage';
import DiagnosticPage from './modules/digital/DiagnosticPage';
import UserGuidePage from './modules/digital/UserGuidePage';
import TrackersPage from './modules/digital/TrackersPage';
import TaxonomyPage from './modules/digital/TaxonomyPage';
import ComparePlansPage from './modules/digital/ComparePlansPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', fontFamily:"'Inter',sans-serif", color:'#6a8aaa' }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/invite/:token" element={<InviteAcceptPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DigitalDashboard />} />
            <Route path="clients" element={<DigitalClientsPage />} />
            <Route path="clients/:id" element={<DigitalClientDetail />} />
            <Route path="brands" element={<BrandsPage />} />
            <Route path="overview" element={<AccountOverviewPage />} />
            <Route path="brands/:id" element={<BrandDetail />} />
            <Route path="plans/:id" element={<DigitalPlanEditor />} />
            <Route path="platforms" element={<PlatformsPage />} />
            <Route path="sites" element={<SitesPage />} />
            <Route path="agency-summary" element={<AgencySummaryPage />} />
            <Route path="audiences" element={<AudiencesPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="diagnostic" element={<DiagnosticPage />} />
            <Route path="diagnostic/:brandId" element={<DiagnosticPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="user-guide" element={<UserGuidePage />} />
            <Route path="trackers" element={<TrackersPage />} />
            <Route path="taxonomy" element={<TaxonomyPage />} />
            <Route path="compare" element={<ComparePlansPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
